/* unplugin-vue-components disabled */import script from "./DeviceConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceConfig.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceConfig.vue?vue&type=style&index=0&id=581f6041&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581f6041"]])

export default __exports__